// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3B7jS","file":"styles_file__3cfMS"};